import { inject,Injectable } from '@angular/core';
import { DpModalService, HeaderAction } from '@docpath/webcomponents';
import { faMagnifyingGlass, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

import { Alias } from '../../models/alias';
import { AliasService } from '../../services/alias.service';
import { AliasFormService } from '../../services/alias-form.service';
import { AliasHttpService } from '../../services/alias-http.service';
import { AliasTableService } from '../table/alias-table.service';

@Injectable({
    providedIn: 'root'
})
export class AliasHeaderService {
    private readonly i18nPrefix = 'alias-config.alias-row';

    private readonly aliasService = inject(AliasService);
    private readonly aliasHttpService = inject(AliasHttpService);
    private readonly aliasFormService = inject(AliasFormService);
    private readonly modalService = inject(DpModalService);
    private readonly aliasTableService = inject(AliasTableService);

    getRightActions(): HeaderAction[] {
        return [
            this.initNewAliasAction(),
            this.initSearchAction()
        ];
    }

    getMoreActions(selectedAlias: Alias[]): HeaderAction[] {
        const actions = [];

        if (selectedAlias.length > 0) {
            actions.push(this.initDeleteAction(selectedAlias));
        }

        return actions;
    }

    getLeftActions(selectedAlias: Alias[]): HeaderAction[] {
        const actions = [];

        if (selectedAlias.length === 1) {
            const aliasSelected = selectedAlias[0];
            actions.push(this.initEditAction(aliasSelected));
        }

        return actions;
    }

    private initSearchAction(): HeaderAction {
        const action = new HeaderAction(`${this.i18nPrefix}.header.search.label`, { cssClass: 'btn btn-dpsecondary' });
        action.tooltip = `${this.i18nPrefix}.header.search.tooltip`;
        action.icon = faMagnifyingGlass;

        return action;
    }

    private initNewAliasAction(): HeaderAction {
        const action = new HeaderAction(`${this.i18nPrefix}.header.new-alias.label`);

        action.icon = faPlusCircle;
        action.tooltip = `${this.i18nPrefix}.header.new-alias.tooltip`;
        action.action = () => this.aliasFormService.openCreateAliasForm();
        this.aliasTableService.loadAlias([], 1);

        return action;
    }

    private initDeleteAction(alias: Alias[]): HeaderAction {
        const action = new HeaderAction(`${this.i18nPrefix}.header.delete.label`);

        action.tooltip = `${this.i18nPrefix}.header.delete.tooltip`;
        action.action = () => this.deleteAlias(alias);

        return action;
    }

    getSearchAction(actions: HeaderAction[]): HeaderAction {
        return actions[1];
    }

    private deleteAlias(aliasList: Alias[]): void {
        const aliasIds = aliasList.map(aliaselement => aliaselement.id),
            modal = this.modalService.openQuestion(`${this.i18nPrefix}.modal.delete-question`);

        modal.componentInstance.accepted.subscribe(() => {
            this.deleteAliasRequest(aliasIds);
        });
    }

    private deleteAliasRequest(aliasIds: number[]): void {
        this.aliasHttpService.deleteAlias(aliasIds, () => {
            this.aliasService.notifyAliasChange();
        });
    }

    private initEditAction(alias: Alias): HeaderAction {
        const action = new HeaderAction(`${this.i18nPrefix}.header.edit.label`);

        action.tooltip = `${this.i18nPrefix}.header.edit.tooltip`;
        action.action = () => this.aliasFormService.openEditAliasForm(alias);

        return action;
    }


}
